import { createFileRoute, Outlet } from '@tanstack/react-router';

import classes from './dashboard.module.css';

export const Route = createFileRoute('/dashboard')({
  component: RouteComponent,
});

function RouteComponent() {
  return (
    <div className={classes.main}>
      <Outlet />
    </div>
  );
}
